// extracted by mini-css-extract-plugin
module.exports = {"connectorPic":"PageHeader_connectorPic__3n6ii"};